<template>
  <div id="default-settings">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <form>
          <vx-card>
            <vs-row vs-w="12" class="mb-10">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="1"
                vs-sm="4"
                vs-xs="12"
              >
                <vs-button
                  @click="goBack"
                  color="danger"
                  type="border"
                  icon="keyboard_backspace"
                  >Back</vs-button
                >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="9"
                vs-sm="4"
                vs-xs="12"
              >
                <h3>Default Settings</h3>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="2"
                vs-sm="4"
                vs-xs="12"
              >
              </vs-col>
            </vs-row>

            <div class="vx-col sm:w-1/6 w-full mb-10">
              <h4>Global Settings</h4>
            </div>
            <div class="vx-col sm:w-1/6 w-full mb-10">
              <h6>Work Availability</h6>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Available</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-radio
                  v-model="work_availability.available"
                  vs-value="available"
                  ><span class="ml-5">Please set work time </span></vs-radio
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Not available</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-radio
                  v-model="work_availability.available"
                  vs-value="not-available"
                  ><span class="ml-5">Please set time off</span></vs-radio
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Working Days</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div class="vx-row mb-6">
                  <template v-for="(days, index) in work_availability.dow">
                    <vs-checkbox
                      :checked="days.checked"
                      :key="index"
                      v-model="days.checked"
                      name="dow"
                      v-validate="'required'"
                      >{{ days.name }}</vs-checkbox
                    >
                  </template>
                </div>
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('dow')"
                  >{{ errors.first("dow") }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Default Availability Hours</span>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Start</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <flat-pickr
                    :config="configTimePicker"
                    v-model="work_availability.start_time"
                    placeholder="Choose start time"
                    name="start_time"
                  />
                </div>
              </div>
              <span
                class="text-danger text-sm mt-2"
                v-show="errors.has('start_time')"
                >{{ errors.first("start_time") }}</span
              >
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full"></div>

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>End</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <flat-pickr
                    :config="configTimePicker"
                    v-model="work_availability.end_time"
                    placeholder="Choose end time"
                    name="end_time"
                  />
                </div>
              </div>
              <span
                class="text-danger text-sm mt-2"
                v-show="errors.has('end_time')"
                >{{ errors.first("end_time") }}</span
              >
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Working Hours Per Day</span>
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input-number
                  min="0"
                  max="24"
                  v-model="work_availability.working_hours_per_day"
                  v-validate="'required'"
                  name="working_hours_per_day"
                />
              </div>
              <span
                class="text-danger text-sm mt-2"
                v-show="errors.has('working_hours_per_day')"
                >{{ errors.first("working_hours_per_day") }}</span
              >
            </div>

            <div class="vx-row">
              <vs-col
                class="p-2"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-xs="6"
              >
                <vs-button class="mr-3" @click.prevent="validateBeforeSubmit"
                  >Submit</vs-button
                >
              </vs-col>
            </div>
          </vx-card>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moduleCalendarManagement from "@/store/calendar-management/moduleCalendarManagement.js";
import { DateTime } from "luxon";
import moment from "moment";

export default {
  data() {
    return {
      user_id: null,
    user_role: null,
      new_default_settings: true,
      todaysDate: new Date(),
      endingDate: moment().add(2, "Y"),
      configTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },
      work_availability: {
        schedule_type : 'default_settings',
        allBetweenDates: [],
        user_id: null,
        dow: [],
        dow: [
          {
            name: "Sunday",
            slug: "0",
            checked: false
          },
          {
            name: "Monday",
            slug: "1",
            checked: false
          },
          {
            name: "Tuesday",
            slug: "2",
            checked: false
          },
          {
            name: "Wednesday",
            slug: "3",
            checked: false
          },
          {
            name: "Thursday",
            slug: "4",
            checked: false
          },
          {
            name: "Friday",
            slug: "5",
            checked: false
          },
          {
            name: "Saturday",
            slug: "6",
            checked: false
          }
        ],
        working_hours_per_day: 0,
        start_time: null,
        end_time: null,
        available: "available",
        datetime: null
      }
    };
  },
  components: {
    flatPickr
  },
  created() {
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleCalendarManagement.isRegistered) {
      this.$store.registerModule(
        "calendarManagement",
        moduleCalendarManagement
      );
      moduleCalendarManagement.isRegistered = true;
    }

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.work_availability.user_id = userInfo["uid"];
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (this.user_role == 'Client Administrator' && this.user_role == 'Client'){
      this.$router.replace("/unauthorized")
    }

  },
  mounted() {
    this.fetchDefaultSettings();
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        console.log(result);
        if (result) {
          this.addDefaultSettings();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    addDefaultSettings() {
      let self = this;
      self.work_availability.new_default_settings = this.new_default_settings;

      let dow = self.work_availability.dow.filter(function(ele) {
        if (ele.checked == true) {
          return ele;
        }
      });
      dow = dow.map(({ slug }) => slug);
      self.work_availability.dow = dow.toString();

        if (
              self.work_availability.start_time == "00:00" &&
               self.work_availability.end_time == "00:00"
            ){
              self.work_availability.allDay = true
            }else{
              self.work_availability.allDay = false
            }

      //assign all between Dates
      this.getAllBetweenDates(this.todaysDate, this.endingDate, dow);

      this.$vs.loading();


      this.$store
        .dispatch(
          "calendarManagement/setDefaultSettings",
          this.work_availability
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Default Settings",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Default Settings",
              text: res.data.message
            });
          }
          this.$vs.loading.close();
          this.$router.push("/calendar");
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllBetweenDates(start_date, end_date, weekDays) {
      var weekDaysOfNumbers = weekDays.map(parseFloat);
      var allDates = [];
      weekDaysOfNumbers.forEach(function(ele) {
        var start = moment(start_date), // Sept. 1st
          end = moment(end_date), // Nov. 2nd
          day = ele; // Sunday

        var result = [];
        var current = start.clone();

        while (current.day(7 + day).isBefore(end)) {
          result.push(current.clone());
        }

        allDates.push(result.map(m => m.format("YYYY-MM-DD")));
      });
      this.work_availability.allBetweenDates = allDates;
    },
    // getUKTimeZone() {
    //   var local = DateTime.local();
    //   var rezoned = local.setZone("Europe/London");
    //   this.UKTimezone =
    //     rezoned.zoneName +
    //     "   |   " +
    //     rezoned.monthShort +
    //     " " +
    //     rezoned.day +
    //     " " +
    //     rezoned.year +
    //     "   |   " +
    //     rezoned.hour +
    //     " : " +
    //     rezoned.minute +
    //     " : " +
    //     rezoned.second;
    // },
    goBack: function() {
      this.$router.go(-1);
    },
    fetchDefaultSettings() {
      this.$store
        .dispatch(
          "calendarManagement/fetchDefaultSettings",
          this.work_availability.user_id
        )
        .then(res => {
          if (res) {
            if (res.data != null) {
              this.new_default_settings = false;
              this.work_availability = res.data;
              this.work_availability.schedule_type = 'default_settings'
              if (this.work_availability.available) {
                this.work_availability.available = "available";
              } else {
                this.work_availability.available = "not-available";
              }
              let stored_dow = this.work_availability.dow.split(
                ","
              );
              this.work_availability.dow = [
                {
                  name: "Sunday",
                  slug: "0",
                  checked: false
                },
                {
                  name: "Monday",
                  slug: "1",
                  checked: false
                },
                {
                  name: "Tuesday",
                  slug: "2",
                  checked: false
                },
                {
                  name: "Wednesday",
                  slug: "3",
                  checked: false
                },
                {
                  name: "Thursday",
                  slug: "4",
                  checked: false
                },
                {
                  name: "Friday",
                  slug: "5",
                  checked: false
                },
                {
                  name: "Saturday",
                  slug: "6",
                  checked: false
                }
              ];
              this.work_availability.dow.forEach(element => {
                if (stored_dow.includes(element.slug)) {
                  element.checked = true;
                }
              });

            } else {
              this.new_default_settings = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 404) {
            console.log(err);
          }
          console.error(err);
        });
    }
  }
};
</script>
